export enum AddressGeologicType {
  LOADING = 0,
  RECENT = 99,
  SUGGESTED = 100,
  CURRENT = 101,
  FAVORITE_HOME = 102,
  FAVORITE_OFFICE = 103,
  FAVORITE_OTHER = 104,
}
